import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const handleSmoothScroll = (id) => {
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <section className="py-20 bg-background-light dark:bg-background-dark">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-text-light dark:text-text-dark">
            Hi, I'm <span className="text-primary-light dark:text-primary-dark">Sebastián Glonek</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-text-light dark:text-text-dark">
            Front-end Developer & FPV Enthusiast
          </p>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <button
              onClick={() => handleSmoothScroll('#projects')}
              className="btn btn-primary text-lg"
            >
              View My Work
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;